import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import _uniqueId from 'lodash/uniqueId';
import {Card, LinkText, Checkbox } from "../../index";
import './dropdown.scss';

export const CheckboxMenu = ({
    disabledOptions,
    id,
    multiselectCount,
    onClick = () => { },
    onDeselectAllClick = () => { },
    onKeyDown = () => { },
    onSelectAllClick = () => { },
    options,
    required = false,
    selectedOptions,
    showSelectAll
}) => {

    const overflowLength = showSelectAll ? 3 : 4;
    const disabledOptionsCount = disabledOptions ? disabledOptions?.length : 0;
    // Show deselect all if reach multiselect count or length of options minus disabled options
    const showDeselectAll = multiselectCount ? selectedOptions?.length >= multiselectCount : selectedOptions?.length >= (options?.length - disabledOptionsCount);

    return (<div
        id={`${id}-list`}
        className={`bsw-checkbox-menu bsw-dropdown__options ${options?.length > overflowLength ? 'options-overflow' : ''}`}
        role="listbox"
        aria-labelledby={id}
        aria-multiselectable="true"
        tabIndex="-1"
    >
        {showSelectAll &&
            <Card className="select-all-option">
                <LinkText
                    onClick={(e) => {showDeselectAll ? onDeselectAllClick(e) :  onSelectAllClick(e) }}
                    typographyType="body-02"
                    as={<button type="button"></button>}
                >
                    {showDeselectAll ? `Deselect all` : `Select all`}
                </LinkText>
            </Card>
        }
        {options && options.map((opt, index) => {
                const optionIndex = required ? index.toString() : (index + 1).toString();
                return (
                    <Checkbox
                        disabled={disabledOptions?.length > 0 ? disabledOptions.some(dOpt => dOpt.value === opt.value) : false}
                        id={`${id}-option-${optionIndex}`}
                        key={index}
                        label={opt.label}
                        onClick={(e) => onClick(e, opt.value, opt.label)}
                        onKeyDown={(e) => onKeyDown(e, opt.value, opt.label)}
                        role="option"
                        value={selectedOptions?.length > 0 ? selectedOptions.some(sOpt => sOpt.value === opt.value) : false}
                        variant="select"
                    />
                )
            })
        }
    </div>)
}

CheckboxMenu.propTypes = {
    disabledOptions: PropTypes.array,
    id: PropTypes.string,
    multiselectCount: PropTypes.number,
    onClick: PropTypes.func,
    onDeselectAllClick: PropTypes.func,
    onKeyDown: PropTypes.func,
    onSelectAllClick: PropTypes.func,
    options: PropTypes.array,
    required: PropTypes.bool,
    selectedOptions: PropTypes.array,
    showSelectAll: PropTypes.bool,
}